module.exports = __webpack_public_path__ + "img/wzyy-bg.8fc741d5.jpg";